import { z } from "zod";

import { socialStatusesData } from "@constants/patientForms";

import { multiSelectResponseSchema } from "../../common/schemaHelper";

/**
 * Social History validation schema
 * Validates the entire social history category
 */

export const socialHistoryValidation = z.object({
  maritalStatus: z.string().min(1, "Please select an option"),
  socialStatuses: z.array(multiSelectResponseSchema),
});

export default socialHistoryValidation;
